import { useEffect, useState } from "react";
import { Smartphone } from "lucide-react";
import { Guide, isIOS, isStandalone } from "@/components/chat/InstallApp";

export const TeamInstall = () => {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(isStandalone());
  const [guide, setGuide] = useState(false);
  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => { setInstalled(true); setPrompt(null); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, []);
  if (installed) return null;
  const install = async () => {
    if (isIOS()) { window.location.href = "/equipe.html"; return; }
    if (!prompt) { setGuide(true); return; }
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "accepted") setInstalled(true);
    setPrompt(null);
  };
  return (
    <>
      <button type="button" data-testid="team-install-button" onClick={install} aria-label="Instalar app da equipe"
        className="flex shrink-0 items-center gap-2 rounded-full border border-zap-gold/60 px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-white/10 md:mx-2 md:justify-center md:py-2 md:text-sm">
        <Smartphone className="h-4 w-4 text-zap-gold" /><span className="md:hidden">Instalar</span><span className="hidden md:inline">Instalar app da equipe</span>
      </button>
      <Guide open={guide} onClose={() => setGuide(false)} ios={isIOS()} icon="/team-icon-192.png?v=1" title="App da equipe na tela inicial"
        desc="Um ícone “IUDP Equipe” que abre direto nas Conversas do painel. Abra esta página pelo endereço zapiudp.com.br/admin antes de instalar." />
    </>
  );
};
